import { titleCase } from "utils/formatting";

export const COMMENT_LABEL = "status update";
export const COMMENTS_TITLE = `${titleCase(COMMENT_LABEL)}s`;
